import React, { useEffect, useState } from "react";

const LinkedInCallback = () => {
  const [userInfo, setUserInfo] = useState(null);
  const clientId = "YOUR_LINKEDIN_CLIENT_ID";
  const clientSecret = "YOUR_LINKEDIN_CLIENT_SECRET";
  const redirectUri = "YOUR_REDIRECT_URI";

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authorizationCode = urlParams.get("code");

    if (authorizationCode) {
      const fetchToken = async () => {
        const response = await fetch(
          "https://www.linkedin.com/oauth/v2/accessToken",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              grant_type: "authorization_code",
              code: authorizationCode,
              redirect_uri: redirectUri,
              client_id: clientId,
              client_secret: clientSecret,
            }),
          }
        );

        const data = await response.json();
        const accessToken = data.access_token;
        if (accessToken) {
          fetchUserProfile(accessToken);
        } else {
          console.error("Failed to retrieve access token");
        }
      };

      const fetchUserProfile = async (accessToken: string) => {
        const profileResponse = await fetch("https://api.linkedin.com/v2/me", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "X-Restli-Protocol-Version": "2.0.0",
          },
        });

        const profileData = await profileResponse.json();
        setUserInfo(profileData);
      };

      fetchToken();
    }
  }, []);

  return (
    <div>
      {userInfo ? (
        <div>
          <h2>Welcome</h2>
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default LinkedInCallback;
